import axiosInstance from '@/common/axiosInstance'
import apiCall from './apiCall'
import { ListSireReviewInvoices } from '@/types/sireReviewInvoice.interface'

interface PaginationParams {
  pageNumber: number
  pageSize: number
}

interface GetListSireReviewInvoicesParams extends PaginationParams {
  search: string
  paymentStatus: string
  invoiceStatus: string
  status: number | string
}

interface GetListSireReviewInvoicesByReviewerParams
  extends GetListSireReviewInvoicesParams {
  reviewerId: string
}

export type SireReviewReviewerInvoice = {
  id: string
  inspectionCompanyId: string
  inspectionCompanyName: string
  invoiceNumber: string
  invoiceDate: string
  reviewMonth: number
  reviewYear: number
  totalReview: number
  costReview: number
  totalAmount: number
  currency: string
  invoiceStatus: number
  paymentStatus: number
  invoiceDownloadId: string | null
  notes: string | null
  transactionStatus: number
}

export type SireReviewSimple = {
  id: string
  sireReviewId: string
  sequenceId: string
  requestorId: string
  requestor: string
  vesselId: string
  vesselName: string
  imoNumber: string
  vesselType: string
  addAldPertamina: string
  reviewDate: string
  created: string
  createdBy: string
  isDeleted: boolean
  modified: string
  modifiedBy: string
}

export const getListSireReviewInvoices = async (
  param: GetListSireReviewInvoicesParams
): Promise<ListSireReviewInvoices> => {
  const query = `?search=${param.search}&paymentStatus=${param.paymentStatus}&invoiceStatus=${param.invoiceStatus}&status=${param.status}&pageNumber=${param.pageNumber}&pageSize=${param.pageSize}`
  const URL = `/SireReviewInvoice/GetListSireReviewInvoices${query}`
  return apiCall('get', URL)
}

export const getListSireReviewInvoicesForFinance = async (
  param: GetListSireReviewInvoicesParams
) => {
  const query = `?search=${param.search}&paymentStatus=${param.paymentStatus}&invoiceStatus=${param.invoiceStatus}&status=${param.status}&pageNumber=${param.pageNumber}&pageSize=${param.pageSize}`
  const URL = `/SireReviewInvoice/GetListSireReviewInvoicesForFinance${query}`
  return apiCall('get', URL)
}

export const getListSireReviewInvoicesByReviewer = async (
  param: GetListSireReviewInvoicesByReviewerParams
) => {
  const query = `?inspectingCompanyId=${param.reviewerId}&search=${param.search}&paymentStatus=${param.paymentStatus}&invoiceStatus=${param.invoiceStatus}&status=${param.status}&pageNumber=${param.pageNumber}&pageSize=${param.pageSize}`
  const URL = `/SireReviewInvoice/GetListSireReviewInvoicesByReviewer${query}`
  return apiCall('get', URL)
}

export const getSireReviewReviewerInvoiceDetails = async (id: string) => {
  const query = `?Id=${id}`
  const URL = `/SireReviewInvoice/GetSireReviewInvoiceById${query}`
  return apiCall('get', URL)
}

export const getListSireReviewsSimpleForReviewer = async (
  month: number,
  year: number,
  inspectingCompanyId: string,
  pageNumber: number,
  pageSize: number
) => {
  const query = `?month=${month}&year=${year}&inspectingCompanyId=${inspectingCompanyId}&pageNumber=${pageNumber}&pageSize=${pageSize}`
  const URL = `/SireReviewInvoice/GetSireReviewDataForInvoiceDetails${query}`
  return apiCall('get', URL)
}

export const getListSireReviewsSimpleByInvoice = async (
  id: string,
  pageNumber: number,
  pageSize: number
) => {
  const query = `?id=${id}&pageNumber=${pageNumber}&pageSize=${pageSize}`
  const URL = `/SireReviewInvoice/GetListSireReviewInvoiceDetailsById${query}`
  return apiCall('get', URL)
}

export const postCreateInvoicesSireReviewReviewer = async (data: any) => {
  const URL = '/SireReviewInvoice/Create'
  // return apiCall('post', URL, data);
  try {
    const response = await axiosInstance.post<any>(URL, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  } catch (err: any) {
    const obj = {
      status: err?.response?.status,
      message: err?.response?.data?.message,
    }
    return obj
  }
}

export const postCreateInvoicesSireReviewReviewerFiles = async (
  data: FormData
) => {
  const URL = '/SireReviewInvoice/UploadFiles'
  // return apiCall('post', URL, data);
  try {
    const response = await axiosInstance.post<any>(URL, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  } catch (err: any) {
    const obj = {
      status: err?.response?.status,
      message: err?.response?.data?.message,
    }
    return obj
  }
}

export const postUpdateSireReviewReviewerInvoice = async (data: FormData) => {
  const URL = '/SireReviewInvoice/Update'
  // return apiCall('post', URL, data);
  try {
    const response = await axiosInstance.post<any>(URL, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  } catch (err: any) {
    const obj = {
      status: err?.response?.status,
      message: err?.response?.data?.message,
    }
    return obj
  }
}

export const postUpdateInvoiceStatusInspector = async (data: {
  id: string
  invoiceStatus: string | number
  notes?: string
  modifiedBy: string
}) => {
  const URL = '/SireReviewInvoice/UpdateInvoiceStatus'
  return apiCall('post', URL, data)
}

export const postUpdateSireReviewReviewerInvoicePayment = async (
  data: FormData
) => {
  const URL = '/SireReviewInvoice/UpdatePaymentStatus'
  // return apiCall('post', URL, data);
  try {
    const response = await axiosInstance.post<any>(URL, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  } catch (err: any) {
    const obj = {
      status: err?.response?.status,
      message: err?.response?.data?.message,
    }
    return obj
  }
}

export const deleteSireReviewReviewerInvoice = async (
  id: string,
  userEmail: string
) => {
  const URL = '/SireReviewInvoice/Delete'
  const data = {
    id,
    modifiedBy: userEmail,
  }
  // return apiCall('post', URL, data);
  try {
    const response = await axiosInstance.post<any>(URL, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    return response.data
  } catch (err: any) {
    const obj = {
      status: err?.response?.status,
      message: err?.response?.data?.message,
    }
    return obj
  }
}
